import { inject, Injectable, Signal } from '@angular/core';
import { UserAuthorizeType } from '@lentau/auth/shared/enums';
import { IS_B2B } from '@lentau/profile/organizations/legal-entity/shared/tokens/is-b2b-profile.token';

@Injectable({
  providedIn: 'root',
})
export class BusinessTypeFactory {
  private isB2B: Signal<boolean> = inject(IS_B2B);

  public get(): string {
    if (this.isB2B()) {
      return UserAuthorizeType.B2B;
    }

    return UserAuthorizeType.B2C;
  }
}
